<div class="header">
    <h2 mat-dialog-title>{{data?.title}}</h2>
    <button
        mat-icon-button
        type="button"
        [disabled]="isConfirming"
        (click)="onDismiss()"
        aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>
    <p class="confirm-dialog-message">{{ data?.message }}</p>
    <p *ngIf="data?.note" class="confirm-dialog-note">
      <span class="confirm-dialog-note__prefix">Note:</span>
      {{ data.note }}
    </p>
</div>

<div mat-dialog-actions [align]="'end'">
    <button
        mat-button
        type="button"
        class="cancel"
        [disabled]="isConfirming"
        (click)="onCancel()">
        {{data?.cancelCaption}}
    </button>
    <button
        mat-raised-button
        type="button"
        class="confirm"
        [disabled]="isConfirming"
        (click)="onConfirm()">
        <mat-spinner
            *ngIf="isConfirming"
            diameter="20"
            class="confirm-spinner">
        </mat-spinner>
        <span>{{ isConfirming ? 'Deleting...' : data?.confirmCaption }}</span>
    </button>
</div>
